module.exports = __webpack_public_path__ + "static/media/attendAILogo.083f0870.webp";